var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.068,
    viewBox: "0 0 20 20.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.125 -1.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.782,1.01l-9.657,4.6V8h20v-2.4Zm9.01,5.668H2.458V6.433L10.8,2.463l8.99,3.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125,31.845h20V27.563h-20ZM2.458,28.88H19.792v1.647H2.458Z",
    transform: "translate(0 -10.767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.063,14.625H6.381v6.589H5.063Z",
    transform: "translate(-1.632 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.688,14.625h1.318v6.589H28.688Z",
    transform: "translate(-11.187 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.938,14.625h1.318v6.589H12.938Z",
    transform: "translate(-4.807 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.813,14.625h1.318v6.589H20.813Z",
    transform: "translate(-8.011 -5.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.831851e96242a2d1e915b5422afaa6fe.svg";
export { ForwardRef as ReactComponent };